import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveIndividual = async (customer,contact,navigate) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
        let Payload  =
            {
              "customerID": customer.customerID,
              "customerType": customer.customerType,
              "firstName": customer.firstName,
              "lastName":  customer.lastName,
              "companyName": customer.companyName,
              "email": customer.email,
              "isLead": customer.isLead,
              "referredBy": customer.referredBy,
              "soldBy": customer.soldBy,
              "companyAddress_Street1": customer.companyAddress_Street1,
              "companyAddress_Street2": customer.companyAddress_Street2,
              "companyAddress_FloorLevel": customer.companyAddress_FloorLevel,
              "companyAddress_UnitNumber": customer.companyAddress_UnitNumber,
              "companyAddress_City": customer.companyAddress_City,
              "companyAddress_State": customer.companyAddress_State,
              "companyAddress_ZipCode": customer.companyAddress_ZipCode,
              "companyAddress_County": customer.companyAddress_County,          
              "billingAddress": customer.billingAddress,
              "billingAddress_Street1": customer.billingAddress_Street1,
              "billingAddress_Street2": customer.billingAddress_Street2,
              "billingAddress_FloorLevel": customer.billingAddress_FloorLevel,
              "billingAddress_UnitNumber": customer.billingAddress_UnitNumber,
              "billingAddress_City": customer.billingAddress_City,
              "billingAddress_State": customer.billingAddress_State,
              "billingAddress_ZipCode": customer.billingAddress_ZipCode,
              "billingAddress_County": customer.billingAddress_County,
              "timeZone": customer.timeZone,
              "phoneNumbers": customer.phoneNumbers,
              "contact": customer.customerType.toLowerCase() == "business"? contact : null,
              "isActive": customer.isActive,              
              "tags": customer.tags
              
            };
     
          console.log(Payload);
      const response = await fetch(`${dev_baseUrl}/Customer/saveIndividual`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });
      
      const data = await response.json();                      
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {      
        return data;
      }       
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
